module.exports = __webpack_public_path__ + "static/UNITY-Square-Two-1st-floor-traditional_v2-2581b7712cb7a626e504d06c5409f3d8.pdf";